'use client';

import React from 'react';
import { FormInput } from './FormInput';
import { FormSelect } from './FormSelect';
import type { UseFormRegister, FieldValues, Path } from 'react-hook-form';
import { cn } from '@/lib/utils';

interface BudgetInputProps<T extends FieldValues> {
  amountName: Path<T>;
  denomName: Path<T>;
  register: UseFormRegister<T>;
  amountError?: string;
  denomError?: string;
  className?: string;
  disabled?: boolean;
}

export function BudgetInput<T extends FieldValues>({
  amountName,
  denomName,
  register,
  amountError,
  denomError,
  className,
  disabled = false,
}: BudgetInputProps<T>) {
  return (
    <div className={cn('w-full space-y-2', className)}>
      <div className="flex flex-col gap-4 sm:flex-row sm:gap-3">
        {/* Base Price Input */}
        <FormInput
          label="Base Price"
          name={amountName}
          type="number"
          register={register}
          error={amountError}
          placeholder="Enter base price"
          disabled={disabled}
          className={cn(disabled && 'opacity-75')}
        />

        {/* Budget Denomination Dropdown */}
        <FormSelect
          label="Denomination"
          name={denomName}
          register={register}
          error={denomError}
          disabled={disabled}
          className={cn(disabled && 'opacity-75')}
          options={[
            { value: 'thousands', label: 'Thousand(s)' },
            { value: 'lacs', label: 'Lac(s)' },
            { value: 'crores', label: 'Crore(s)' },
          ]}
        />
      </div>
    </div>
  );
}
